"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8235,7382],{

/***/ 77382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var CategoriesLinks = function(param) {
    var categories = param.categories;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: categories && (categories === null || categories === void 0 ? void 0 : categories.length) > 0 ? (categories === null || categories === void 0 ? void 0 : categories.length) > 1 && ((ref = categories[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.includes("آخر الأخبار")) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: "/category/" + ((ref2 = categories[1]) === null || ref2 === void 0 ? void 0 : ref2.id) + "/" + ((ref3 = categories[1]) === null || ref3 === void 0 ? void 0 : ref3.title),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "#",
                "aria-label": "Go to 56",
                children: (ref4 = categories[1]) === null || ref4 === void 0 ? void 0 : ref4.title
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: "/category/" + ((ref5 = categories[0]) === null || ref5 === void 0 ? void 0 : ref5.id) + "/" + ((ref6 = categories[0]) === null || ref6 === void 0 ? void 0 : ref6.title),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "#",
                "aria-label": "Go to 57",
                children: (ref7 = categories[0]) === null || ref7 === void 0 ? void 0 : ref7.title
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategoriesLinks);


/***/ }),

/***/ 98235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SideBar_SideBar; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/Shared/SideBar/SideBanner/sidebanner.module.css
var sidebanner_module = __webpack_require__(32739);
var sidebanner_module_default = /*#__PURE__*/__webpack_require__.n(sidebanner_module);
// EXTERNAL MODULE: ./components/Shared/AdSlot/AdSlot.tsx
var AdSlot = __webpack_require__(17261);
// EXTERNAL MODULE: ./components/AdBlock/adspace.tsx
var adspace = __webpack_require__(25295);
;// CONCATENATED MODULE: ./components/Shared/SideBar/SideBanner/SideBanner.tsx




var SideBanner = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            size === "Small" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdSlot/* default */.Z, {
                        id: "div-gpt-ad-1658152742263-0",
                        screen: "web"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdSlot/* default */.Z, {
                        id: "div-gpt-ad-1658153281882-0",
                        screen: "mobile"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(adspace/* default */.Z, {
                        id: "div-Desk_Between_300x250",
                        width: 250,
                        height: 250,
                        screen: "web"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(adspace/* default */.Z, {
                        id: "div-Mobile_Inner_Page300X250",
                        width: 250,
                        height: 250,
                        screen: "mobile"
                    })
                ]
            }),
            size === "Large" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (sidebanner_module_default()).largeBanner,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdSlot/* default */.Z, {
                            id: "div-gpt-ad-1658152770792-0",
                            screen: "web"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(adspace/* default */.Z, {
                            id: "div-Desk_Between_300x600",
                            width: 300,
                            height: 480,
                            screen: "web"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdSlot/* default */.Z, {
                            id: "div-gpt-ad-1658152230777-0",
                            screen: "mobile"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(adspace/* default */.Z, {
                            id: "div-APP_Bottom_300x250",
                            width: 300,
                            height: 50,
                            screen: "mobile"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var SideBanner_SideBanner = (SideBanner);

// EXTERNAL MODULE: ./components/Shared/SideBar/SideList/sidelist.module.css
var sidelist_module = __webpack_require__(64101);
var sidelist_module_default = /*#__PURE__*/__webpack_require__.n(sidelist_module);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./styles/images/cnbc-default-image.webp
var cnbc_default_image = __webpack_require__(61310);
// EXTERNAL MODULE: ./components/Title/index.tsx
var Title = __webpack_require__(50501);
// EXTERNAL MODULE: ./services/GetData.ts
var GetData = __webpack_require__(17004);
// EXTERNAL MODULE: ./services/Requests.ts
var Requests = __webpack_require__(19061);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Shared/TimeAgoCustom/TimeAgoArabicFormat.tsx
var TimeAgoArabicFormat = __webpack_require__(4526);
// EXTERNAL MODULE: ./components/Shared/CategoriesLinks/CategoriesLinks.tsx
var CategoriesLinks = __webpack_require__(77382);
// EXTERNAL MODULE: ./components/Home/LatestNewsList/LatestNewsList.tsx
var LatestNewsList = __webpack_require__(92082);
// EXTERNAL MODULE: ./components/Shared/SkeletonLoader/SkeletoLoader.tsx
var SkeletoLoader = __webpack_require__(58663);
// EXTERNAL MODULE: ./services/ResponseMapping.ts
var ResponseMapping = __webpack_require__(28427);
// EXTERNAL MODULE: ./services/ArabicTitles.tsx
var ArabicTitles = __webpack_require__(9419);
// EXTERNAL MODULE: ./services/Util.ts
var Util = __webpack_require__(80368);
// EXTERNAL MODULE: ./components/Thumbnail/index.tsx
var Thumbnail = __webpack_require__(13009);
;// CONCATENATED MODULE: ./components/Shared/SideBar/SideList/SideList.tsx
















var SideList = function(param) {
    var type = param.type, title = param.title;
    var ref = (0,react.useState)({}), mostReadNewsList = ref[0], setMostReadNewsList = ref[1];
    var ref1 = (0,react.useState)([]), trendingNewsList = ref1[0], setTrendingNewsList = ref1[1];
    var ref2 = (0,react.useState)([]), marketNewsList = ref2[0], setMarketNewsList = ref2[1];
    var ref3 = (0,react.useState)([]), stockNewsList = ref3[0], setStockNewsList = ref3[1];
    var ref4 = (0,react.useState)(false), trendingLoader = ref4[0], setTrendingLoader = ref4[1];
    var ref5 = (0,react.useState)(false), mostReadLoader = ref5[0], setMostReadLoader = ref5[1];
    var ref6 = (0,react.useState)(false), marketLoader = ref6[0], setMarketLoader = ref6[1];
    var ref7 = (0,react.useState)(false), stockLoader = ref7[0], setStockLoader = ref7[1];
    (0,react.useEffect)(function() {
        if (title != "أخبار الأسواق" && title != "أخبار الشركات") {
            setMostReadLoader(true);
            (0,GetData/* default */.Z)("".concat(Requests/* requests.mostReadNews */.E7.mostReadNews, "&limit=5&offset=0"), {}, "get", false).then(function(res) {
                var ref, ref1;
                var newsRes = ((ref = res.data) === null || ref === void 0 ? void 0 : ref.response) ? (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.response : {};
                setMostReadLoader(false);
                setMostReadNewsList(newsRes);
            }).catch(function(err) {
                setMostReadLoader(false);
                console.warn(err);
            });
        } else if (title == "أخبار الأسواق") {
            setMarketLoader(true);
            (0,GetData/* default */.Z)("".concat(Requests/* requests.latestMarketCategory */.E7.latestMarketCategory), {}, "get", false).then(function(res) {
                var ref, ref1;
                var marketNewsCategoryId = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.id;
                marketNewsCategoryId && (0,GetData/* default */.Z)("".concat(Requests/* requests.newsByCategories */.E7.newsByCategories).concat(marketNewsCategoryId, "?limit=6&pageNo=1"), {}, "get", false).then(function(result) {
                    var newsResult = (0,ResponseMapping/* mapFlagBasedResponse */.NG)(result === null || result === void 0 ? void 0 : result.data);
                    setMarketLoader(false);
                    setMarketNewsList(newsResult);
                }).catch(function(err) {
                    setMarketLoader(false);
                    console.warn(err);
                });
            }).catch(function(err) {
                console.warn(err);
            });
        } else if (title == "أخبار الشركات") {
            setStockLoader(true);
            (0,GetData/* default */.Z)("".concat(Requests/* requests.latestStockCategory */.E7.latestStockCategory), {}, "get", false).then(function(res) {
                var ref, ref1;
                var stockNewsCategoryId = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.id;
                stockNewsCategoryId && (0,GetData/* default */.Z)("".concat(Requests/* requests.newsByCategories */.E7.newsByCategories).concat(stockNewsCategoryId, "?limit=6&pageNo=1"), {}, "get", false).then(function(result) {
                    var newsResult = (0,ResponseMapping/* mapFlagBasedResponse */.NG)(result === null || result === void 0 ? void 0 : result.data);
                    setStockLoader(false);
                    setStockNewsList(newsResult);
                }).catch(function(err) {
                    setStockLoader(false);
                    console.warn(err);
                });
            }).catch(function(err) {
                console.warn(err);
            });
        }
        setTrendingLoader(true);
        (0,GetData/* default */.Z)("".concat(Requests/* requests.trendingNews */.E7.trendingNews, "&limit=5&pageNo=1"), {}, "get", false).then(function(res) {
            var newsResult = res.data && res.data.length ? res.data : [];
            newsResult = (0,ResponseMapping/* handleElkAndDbResponse */.hb)(newsResult);
            setTrendingLoader(false);
            setTrendingNewsList(newsResult);
        }).catch(function(err) {
            setTrendingLoader(false);
            console.warn(err);
        });
        return function() {
            // This code runs when component is unmounted
            setMostReadNewsList({});
            setTrendingNewsList([]);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (sidelist_module_default()).sidebar,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (sidelist_module_default()).listBody,
                children: [
                    type === "numbered" && (title === "الأكثر قراءة" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "sideSimpleListWrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                                    styles: (sidelist_module_default()).themeTitle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                        children: [
                                            " ",
                                            title,
                                            " "
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (sidelist_module_default()).sidenumberList,
                                    children: [
                                        mostReadLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletoLoader["default"], {
                                            count: 15
                                        }),
                                        mostReadNewsList && Object.keys(mostReadNewsList).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: Object.values(mostReadNewsList).map(function(newsItem, index) {
                                                var ref;
                                                newsItem["routePath"] = (0,Util/* buildNewsRoute */.uC)(newsItem === null || newsItem === void 0 ? void 0 : newsItem.id, newsItem === null || newsItem === void 0 ? void 0 : newsItem.createdAt, newsItem === null || newsItem === void 0 ? void 0 : (ref = newsItem.seoDetail) === null || ref === void 0 ? void 0 : ref.slugLine, newsItem === null || newsItem === void 0 ? void 0 : newsItem.title);
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/".concat(newsItem === null || newsItem === void 0 ? void 0 : newsItem.routePath, "/"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "#",
                                                            "aria-label": "Go to 116",
                                                            children: newsItem === null || newsItem === void 0 ? void 0 : newsItem.title
                                                        })
                                                    })
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }) : title === "الأكثر تداولا" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "sideSimpleListWrap mostPopular",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                                    styles: (sidelist_module_default()).themeTitle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                        children: [
                                            " ",
                                            ArabicTitles/* trendingNowTitle */.I,
                                            " "
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (sidelist_module_default()).sidenumberList,
                                    children: [
                                        trendingLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletoLoader["default"], {
                                            count: 5
                                        }),
                                        (trendingNewsList === null || trendingNewsList === void 0 ? void 0 : trendingNewsList.length) > 0 && (trendingNewsList === null || trendingNewsList === void 0 ? void 0 : trendingNewsList.map(function(newsItem, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/".concat(newsItem === null || newsItem === void 0 ? void 0 : newsItem.routePath, "/"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#",
                                                        "aria-label": "Go to 117",
                                                        children: newsItem === null || newsItem === void 0 ? void 0 : newsItem.title
                                                    })
                                                })
                                            }, index);
                                        }))
                                    ]
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "sideSimpleListWrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                                    styles: (sidelist_module_default()).themeTitle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                        children: [
                                            " ",
                                            title,
                                            " `",
                                            "static",
                                            "`"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: (sidelist_module_default()).sidenumberList
                                })
                            ]
                        })
                    })),
                    type === "simple" && (title === "الأكثر قراءة" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "sideSimpleListWrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                                    styles: (sidelist_module_default()).themeTitle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                        children: [
                                            " ",
                                            title,
                                            " "
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (sidelist_module_default()).sidesimpleList,
                                    children: [
                                        mostReadLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletoLoader["default"], {
                                            count: 15
                                        }),
                                        mostReadNewsList && Object.keys(mostReadNewsList).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: Object.values(mostReadNewsList).map(function(newsItem, index) {
                                                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
                                                newsItem["routePath"] = (0,Util/* buildNewsRoute */.uC)(newsItem === null || newsItem === void 0 ? void 0 : newsItem.id, newsItem === null || newsItem === void 0 ? void 0 : newsItem.createdAt, newsItem === null || newsItem === void 0 ? void 0 : (ref = newsItem.seoDetail) === null || ref === void 0 ? void 0 : ref.slugLine, newsItem === null || newsItem === void 0 ? void 0 : newsItem.title);
                                                var imagePath = (newsItem === null || newsItem === void 0 ? void 0 : newsItem.contentType) === "VIDEO" && (newsItem === null || newsItem === void 0 ? void 0 : (ref1 = newsItem.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.url) ? newsItem === null || newsItem === void 0 ? void 0 : (ref2 = newsItem.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.url : (newsItem === null || newsItem === void 0 ? void 0 : (ref3 = newsItem.thumbnail) === null || ref3 === void 0 ? void 0 : ref3.path) ? Requests/* fileUrl */._h + (newsItem === null || newsItem === void 0 ? void 0 : (ref4 = newsItem.thumbnail) === null || ref4 === void 0 ? void 0 : ref4.path) : (newsItem === null || newsItem === void 0 ? void 0 : (ref5 = newsItem.image) === null || ref5 === void 0 ? void 0 : ref5.url) ? newsItem === null || newsItem === void 0 ? void 0 : (ref6 = newsItem.image) === null || ref6 === void 0 ? void 0 : ref6.url : (newsItem === null || newsItem === void 0 ? void 0 : (ref7 = newsItem.image) === null || ref7 === void 0 ? void 0 : ref7.path) ? Requests/* fileUrl */._h + (newsItem === null || newsItem === void 0 ? void 0 : (ref8 = newsItem.image) === null || ref8 === void 0 ? void 0 : ref8.path) : cnbc_default_image/* default.src */.Z.src;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "NewsImage show_mobile",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/".concat(newsItem === null || newsItem === void 0 ? void 0 : newsItem.routePath, "/"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "#",
                                                                    "aria-label": "Go to 118",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbnail/* default */.Z, {
                                                                        className: "img-fluid",
                                                                        src: imagePath
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/".concat(newsItem === null || newsItem === void 0 ? void 0 : newsItem.routePath, "/"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "#",
                                                                "aria-label": "Go to 119",
                                                                children: newsItem === null || newsItem === void 0 ? void 0 : newsItem.title
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesLinks/* default */.Z, {
                                                                    categories: newsItem && (newsItem === null || newsItem === void 0 ? void 0 : newsItem.categories)
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeAgoArabicFormat/* default */.Z, {
                                                                        date: newsItem === null || newsItem === void 0 ? void 0 : newsItem.createdAt
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }) : title === "أخبار الشركات" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "sideSimpleListWrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                                    styles: (sidelist_module_default()).themeTitle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                        children: [
                                            " ",
                                            title,
                                            " "
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (sidelist_module_default()).sidesimpleList,
                                    children: [
                                        stockLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletoLoader["default"], {
                                            count: 15
                                        }),
                                        (stockNewsList === null || stockNewsList === void 0 ? void 0 : stockNewsList.length) > 0 && (stockNewsList === null || stockNewsList === void 0 ? void 0 : stockNewsList.map(function(newsItem, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "NewsImage show_mobile image_none_tab",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbnail/* default */.Z, {
                                                            className: "img-fluid",
                                                            src: cnbc_default_image/* default.src */.Z.src
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/".concat(newsItem === null || newsItem === void 0 ? void 0 : newsItem.routePath, "/"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "#",
                                                            "aria-label": "Go to 120",
                                                            children: newsItem === null || newsItem === void 0 ? void 0 : newsItem.title
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesLinks/* default */.Z, {
                                                                categories: newsItem && (newsItem === null || newsItem === void 0 ? void 0 : newsItem.categories)
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeAgoArabicFormat/* default */.Z, {
                                                                    date: newsItem === null || newsItem === void 0 ? void 0 : newsItem.createdAt
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, index);
                                        }))
                                    ]
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "sideSimpleListWrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                                    styles: (sidelist_module_default()).themeTitle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                        children: [
                                            " ",
                                            title,
                                            " "
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (sidelist_module_default()).sidesimpleList,
                                    children: [
                                        marketLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletoLoader["default"], {
                                            count: 15
                                        }),
                                        (marketNewsList === null || marketNewsList === void 0 ? void 0 : marketNewsList.length) > 0 && (marketNewsList === null || marketNewsList === void 0 ? void 0 : marketNewsList.map(function(newsItem, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "NewsImage show_mobile image_none_tab",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbnail/* default */.Z, {
                                                            className: "img-fluid",
                                                            src: cnbc_default_image/* default.src */.Z.src
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/".concat(newsItem === null || newsItem === void 0 ? void 0 : newsItem.routePath, "/"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "#",
                                                            "aria-label": "Go to 121",
                                                            children: newsItem === null || newsItem === void 0 ? void 0 : newsItem.title
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesLinks/* default */.Z, {
                                                                categories: newsItem && (newsItem === null || newsItem === void 0 ? void 0 : newsItem.categories)
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeAgoArabicFormat/* default */.Z, {
                                                                    date: newsItem === null || newsItem === void 0 ? void 0 : newsItem.createdAt
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, index);
                                        }))
                                    ]
                                })
                            ]
                        })
                    })),
                    type === "dotList" && (title === "آخر الأخبار" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                                styles: (sidelist_module_default()).themeTitle,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                    children: [
                                        " ",
                                        title,
                                        " "
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "dotListwrap",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestNewsList/* default */.Z, {
                                    limit: 10,
                                    displayMoreButton: true
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                                styles: (sidelist_module_default()).themeTitle,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                    children: [
                                        " ",
                                        title,
                                        " "
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "dotListwrap",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center mt-3 d-lg-none more_btn",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "btn btn-outline-primary",
                                        children: "المزيد"
                                    })
                                })
                            })
                        ]
                    }))
                ]
            })
        })
    });
};
/* harmony default export */ var SideList_SideList = (SideList);

;// CONCATENATED MODULE: ./components/Shared/SideBar/SideBar.tsx



var SideBar = function(param) {
    var sideBarSequence = param.sideBarSequence;
    sideBarSequence.sort(function(a, b) {
        return a.position < b.position ? -1 : a.position > b.position ? 1 : 0;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: sideBarSequence.map(function(sequence, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    sequence.componentType === "numbered" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SideList_SideList, {
                        type: "numbered",
                        title: sequence.title
                    }, "numbered"),
                    sequence.componentType === "SmallBanner" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sticky-banner",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBanner_SideBanner, {
                            size: "Small"
                        }, "Small")
                    }),
                    sequence.componentType === "simple" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SideList_SideList, {
                        type: "simple",
                        title: sequence.title
                    }, "simple"),
                    sequence.componentType === "dotList" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SideList_SideList, {
                        type: "dotList",
                        title: sequence.title
                    }, "dotList"),
                    sequence.componentType === "LargeBanner" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sticky-banner",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hide_div_mobile",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBanner_SideBanner, {
                                    size: "Large"
                                }, "Large")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hide_div_web",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBanner_SideBanner, {
                                    size: "Small"
                                }, "small")
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ var SideBar_SideBar = (SideBar);


/***/ })

}]);